import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface TabIndexesState {
  careimageTabIndex: number;
  eventTabIndex: number;
  waiterListTabIndex: number;
  waiterDetailTabIndex: number;
  otherOfficeOnlineMeetingsTabIndex: number;
  reservationSchedulesTabIndex: number;
}

/**
 * ### TabIndexes store
 *
 * - store
 *   - 介護記録一覧画面のタブ位置を保持する
 *   - イベント一覧画面のタブ位置を保持する
 * - action, mutation
 *   - 介護記録一覧画面のタブ位置を設定する
 *   - イベント一覧画面のタブ位置を設定する
 */
@Module({ name: "tabIndexes" })
export default class TabIndexes extends VuexModule implements TabIndexesState {
  /** 介護記録一覧画面のタブ位置 */
  careimageTabIndex: number = 0;
  /** イベント一覧画面のタブ位置 */
  eventTabIndex: number = 0;
  /** 待機者一覧 */
  waiterListTabIndex: number = 0;
  /** 待機者詳細 */
  waiterDetailTabIndex: number = 0;
  /** 他事業所連携 オンライン会議 */
  otherOfficeOnlineMeetingsTabIndex: number = 0;
  /** 面会予約スケジュール */
  reservationSchedulesTabIndex: number = 0;

  @Mutation
  private INITIALIZE_TAB_INDEX(): void {
    this.careimageTabIndex = 0;
    this.eventTabIndex = 0;
    this.waiterListTabIndex = 0;
    this.waiterDetailTabIndex = 0;
    this.otherOfficeOnlineMeetingsTabIndex = 0;
    this.reservationSchedulesTabIndex = 0;

    return;
  }

  @Mutation
  private SET_CAREIMAGE_TAB_INDEX(careimageTabIndex: number): void {
    this.careimageTabIndex = careimageTabIndex;
    return;
  }

  @Mutation
  private SET_EVENT_TAB_INDEX(eventTabIndex: number): void {
    this.eventTabIndex = eventTabIndex;
    return;
  }

  @Mutation
  private SET_WAITER_LIST_TAB_INDEX(waiterListTabIndex: number): void {
    this.waiterListTabIndex = waiterListTabIndex;
    return;
  }

  @Mutation
  private SET_WAITER_DETAIL_TAB_INDEX(waiterDetailTabIndex: number): void {
    this.waiterDetailTabIndex = waiterDetailTabIndex;
    return;
  }

  @Mutation
  private SET_OTHER_OFFICE_ONLINE_MEETINGS_TAB_INDEX(otherOfficeOnlineMeetingsTabIndex: number): void {
    this.otherOfficeOnlineMeetingsTabIndex = otherOfficeOnlineMeetingsTabIndex;
    return;
  }

  @Mutation
  private SET_RESERVATION_SCHEDULES_TAB_INDEX(reservationSchedulesTabIndex: number): void {
    this.reservationSchedulesTabIndex = reservationSchedulesTabIndex;
    return;
  }

  @Action({ rawError: true })
  public async initializeTabIndex(): Promise<void> {
    this.INITIALIZE_TAB_INDEX();
    return;
  }

  /**
   * ### 介護記録一覧画面のタブ位置設定
   *
   * - 渡された介護記録一覧画面のタブ位置をstoreに設定する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public async setCareimageTabIndex(payload: { index: number }): Promise<void> {
    this.SET_CAREIMAGE_TAB_INDEX(payload.index);
    return;
  }

  /**
   * ### イベント一覧画面設定
   *
   * - 渡されたイベント一覧画面をstoreに設定する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public async setEventTabIndex(payload: { index: number }): Promise<void> {
    this.SET_EVENT_TAB_INDEX(payload.index);
    return;
  }

  @Action({ rawError: true })
  public async setWaiterListTabIndex(payload: { index: number }): Promise<void> {
    this.SET_WAITER_LIST_TAB_INDEX(payload.index);
    return;
  }

  @Action({ rawError: true })
  public async setWaiterDetailTabIndex(payload: { index: number }): Promise<void> {
    this.SET_WAITER_DETAIL_TAB_INDEX(payload.index);
    return;
  }

  @Action({ rawError: true })
  public async setOtherOfficeOnlineMeetingsTabIndex(payload: { index: number }): Promise<void> {
    this.SET_OTHER_OFFICE_ONLINE_MEETINGS_TAB_INDEX(payload.index);
    return;
  }

  @Action({ rawError: true })
  public async setReservationSchedulesTabIndex(payload: { index: number }): Promise<void> {
    this.SET_RESERVATION_SCHEDULES_TAB_INDEX(payload.index);
    return;
  }
}
